<template>
  <v-menu bottom left>
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item v-for="(option, index) in options" :key="index" @click="$emit('select', option.value)">
        <v-list-item-title class="px-2">{{ option.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'GenericSubMenu',
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
};
</script>
